module.exports = __webpack_public_path__ + "static/media/related-cases2.eb567552.jpg";